import type {
  ProductImagePresetSizes,
  ProductImagePresetUrlAndSize,
  ProductImageSize,
  ProductImagesKeyedByPresetSizeName,
} from './types';

const presetImagePixelSizesByName: ProductImagePresetSizes = {
  micro: 56,
  mini: 90,
  thumb: 130,
  medium: 165,
  category_listing: 229,
  preview: 300,
  normal: 350,
  original: 1024,
};

const sizes: ProductImageSize[] = [
  'thumb',
  'preview',
  'original',
  'normal',
  'mini',
  'micro',
  'medium',
  'category_listing',
];

export const getProductImageURL = (url: string, size: ProductImageSize = 'preview') => {
  const newUrl = url.replace('{size}', size);
  const hasExistingSize = sizes.some((imageSize) => url.includes(`/${imageSize}_`));

  if (newUrl === url && !hasExistingSize) {
    console.warn(`image URL "${url}" does not contain "{size}" token`);
  }

  return newUrl.replace(/%25/g, '%'); // Handle double encoding of special characters. Remove once root cause is fixed
};

const getPresetImageUrlAndDimensions = (
  originalURL: string,
  namedSize: ProductImageSize,
): ProductImagePresetUrlAndSize => ({
  src: getProductImageURL(originalURL, namedSize),
  width: presetImagePixelSizesByName[namedSize],
  height: presetImagePixelSizesByName[namedSize],
});

export const getProductImageSizes = (originalURL: string, namedSizes: ProductImageSize[]) =>
  namedSizes.reduce<ProductImagesKeyedByPresetSizeName>(
    (sizes, namedSize) => ({
      ...sizes,
      [namedSize]: getPresetImageUrlAndDimensions(originalURL, namedSize),
    }),
    {} as ProductImagesKeyedByPresetSizeName,
  );

export const getProductResponsiveImagesForSizes = (
  originalURL: string,
  namedSizes: ProductImageSize[],
) => namedSizes.map((namedSize) => getPresetImageUrlAndDimensions(originalURL, namedSize));
